import { render, staticRenderFns } from "./Line-Item-Invoice.vue?vue&type=template&id=46a48541"
import script from "./Line-Item-Invoice.vue?vue&type=script&lang=js"
export * from "./Line-Item-Invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports